/**
 * component
 */

export const navBar = {
  brand: 'Emamo',

};

export const header = {
  title: '施設',
  timeFormat: 'YYYY/M/DD HH:mm',
  settingButtom: '設定',
  logoutButtom: 'ログアウト',
};

export const notificationItem = {
  timeString: {
    ago: '前',
    after: '后',
    second: 'たった今',
    seconds: 'たった今',
    minute: '分',
    minutes: '分',
    hour: '時間',
    hours: '時間',
    day: '日',
    days: '日',
    week: '週間',
    weeks: '週間',
    month: 'ヶ月',
    months: 'ヶ月',
    year: '年',
    years: '年',
  },
  alerts: {
    SOS: '呼出ボタンが押されました。',
    DoorOpen: 'ドアが開きました。',
    LeaveBed: '離床しました。',
    default: 'Unknown alert type.',
  },
};

export const confirmDialog = {
  confirmButton: 'OK',
  cancelButton: 'キャンセル',
  confirmDeleteNote: {
    headerText: '内容を削除します。',
    bodyText: 'よろしいですか?',
  },
  confirmLogout: {
    headerText: '',
    bodyText: 'ログアウトしますか？',
  },
};

export const roomEditDialog = {
  confirmButton: 'OK',
  cancelButton: 'キャンセル',
  nameTitle: '入居者氏名',
  birthdayTitle: '生年月日',
  sex: '性別',
  male: '男性',
  female: '女性',
};

export const roomDetailDialog = {
  title: '利用者情報',
  edit: '編集',
  heartRate: '心拍数',
  breath: '呼吸数',
  washroom: 'トイレ利用',
  door: 'ドアの開閉',
  temperature: '温度',
  humidity: '湿度',
  presence: '人感センサー',
  lightLevel: '明るさ',
  ageUnit: '歳',
  offBed: 'offline',
};

export const settingDialog = {
  confirmButton: 'OK',
  cancelButton: 'キャンセル',
  title: 'アラート設定',
  alertToggleTitle: 'アラート通知',
  alertTimeTitle: 'アラート時間',
  alertStart: '開始',
  alertEnd: '終了',
  familyListTitle: '部屋番号',
};

export const addUserDialog = {
  confirmButton: 'ADD',
  cancelButton: 'CANCEL',
  title: 'ADD NEW USER',
};

export const noteList = {
  title: '掲示板',
  saveButton: 'OK',
  cancelButton: 'キャンセル',
  editButton: '編集',
  deleteButton: '削除',
  nullscreenText: '新しいアラートはありません',
};

export const loginScreen = {
  usernamePlaceholder: 'Username',
  usernameMissing: 'Please input your username!',
  passwordPlaceholder: 'Password',
  passwordMissing: 'Please input your Password!',
  defaultErrorMsg: 'Wrong username password combination!',
};

export const roomItem = {
  deviceOffline: 'E',
  deviceNull: '-',
  inWashroom: '利用中',
  notInWashroom: '',
  doorOpen: '開',
  doorClose: '閉',
  lightOn: '明るい',
  lightOff: '暗い',
  textDeviceOffline: 'デバイス<br/>オフライン',
};
